<template>
   <div id="landing-wrapper">
      <div id="landing">
         <div class="header-row">
            <h1 class="heading">
               Firdausi Homam
            </h1>
            <p class="tagline">
               Candidate for Trustee, Town of Caledon<br>
               Peel District School Board
            </p>
         </div>

         <div class="subscribe-row">
            <SubscribeButton/>
         </div>

         <div class="content">
            <h2>Why I'm running</h2>

            <p>
               I'm running to give parents, teachers, staff and students a real
               voice in how our schools are run. The Peel District School Board
               needs a direct, continuous channel where everyone with a stake
               in our schools can give feedback that is public and goes
               straight to the board and policy makers, so concerns and ideas
               are tracked and answered rather than lost in a one-off meeting
               or an unanswered email. I spent years working in one of the largest
               feedback operations in the world. I know this can be done well,
               and at scale.
            </p>

            <p>
               The need is clear. The board's 2026 Report Card shows a
               significant share of our students below the provincial standard
               in every category, with mathematics worst of all, at a time when
               science and technology shape every career. The same report shows
               the board failing basic provincial requirements on its code of
               conduct, bullying prevention and accessibility. Meeting those
               requirements is the floor, not the goal. The board needs a plan,
               shaped by what the people in its schools are telling it, to
               improve both student experience and student performance.
            </p>

            <p>
               Children in my family are in Peel schools now, and more will be
               in the coming years. I want to do my part to make sure they, and
               every student in Caledon, are set up for success.
            </p>
         </div>
      </div>
   </div>
</template>

<script>
import SubscribeButton from '@/components/form/SubscribeButton.vue';

export default {
   name: 'Landing',
   components: {
      SubscribeButton,
   },
}
</script>

<style scoped>

/* + General Page Style */

#landing-wrapper {
   position: fixed;
   inset: 0;
   background-color: #001a21;
   z-index: 0;
}

#landing {
   position: relative;
   height: 100%;
   overflow-y: auto;
   box-sizing: border-box;
   padding: 0 1.5rem 4rem;
}

/* - General Page Style */

/* + Header Row */
.header-row {
   padding-top: 9rem;
   padding-bottom: 4rem;
   text-align: center;
}

.heading {
   color: #fdfdfd;
   opacity: 0.88;
   font-size: 3rem;
   font-weight: 600;
   letter-spacing: 0.02em;
   margin: 0 0 1rem;
}

.tagline {
   color: #c9d6d9;
   font-size: 1.25rem;
   line-height: 1.5;
   margin: 0;
}
/* - Header Row */

.subscribe-row {
   display: flex;
   justify-content: center;
   margin-bottom: 3.5rem;
}

/* + Content Row */
.content {
   color: #fdfdfd;
   max-width: 42rem;
   margin: 0 auto;
   font-size: 1.2rem;
   line-height: 1.7;
}

.content h2 {
   font-size: 1.5rem;
   font-weight: 600;
   margin: 0 0 1.5rem;
   color: #fdfdfd;
}

.content p {
   margin: 0 0 1.5rem;
   color: #eaeaea;
}
/* - Content Row */

/* + Responsive UI */
@media screen and (max-width: 640px) {
   .header-row {
      padding-top: 6rem;
      padding-bottom: 3rem;
   }

   .heading {
      font-size: 2.2rem;
   }

   .content {
      font-size: 1.1rem;
   }
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/Landing.vue